import { COMPANY_FILTER_CHANGE } from 'containers/PartnerOptions/constants'
import { QUICK_FILTERS_CHANGE } from 'containers/ResolutionCenter/QuickFilters/constants'

import {
  DATA_REQUEST_ASYNC,
  GENERAL_FILTER_CHANGE,
  PAGINATE_CHANGE,
  SEARCH_CHANGE,
  SEARCH_RESET,
  SET_DETECTED_BY_FILTER,
} from './constants'

export default function () {
  const initialState = {
    data: {
      results: [],
    },
    page: 1,
    search: '',
    loader: false,
    error: null,
    generalFilter: 0,
    detectedByFilter: null,
  }

  return (state = initialState, action) => {
    switch (action.type) {
      case QUICK_FILTERS_CHANGE:
      case COMPANY_FILTER_CHANGE:
        return { ...state, page: 1, loader: true }
      case SEARCH_RESET:
        return {
          ...state,
          search: '',
        }
      case SEARCH_CHANGE:
        return {
          ...state,
          search: action.payload.q,
          loader: true,
          page: 1,
        }
      case GENERAL_FILTER_CHANGE:
        return {
          ...state,
          generalFilter: action.payload.value,
          page: 1,
          loader: true,
          message: null,
        }
      case PAGINATE_CHANGE:
        return {
          ...state,
          page: action.payload.page,
          loader: true,
          message: null,
        }
      case DATA_REQUEST_ASYNC.INITIATE:
        return { ...state, loader: true }
      case DATA_REQUEST_ASYNC.SUCCESS:
        return {
          ...state,
          error: null,
          data: action.payload.data,
          loader: false,
        }
      case DATA_REQUEST_ASYNC.ERROR:
        return {
          ...state,
          loader: false,
          error: action.error,
          data: {
            results: [],
          },
        }
      case DATA_REQUEST_ASYNC.CANCEL:
        return { ...state, loader: false, page: 1 }
      case SET_DETECTED_BY_FILTER:
        return {
          ...state,
          detectedByFilter: action.payload.values,
        }
      default:
        return state
    }
  }
}
